import { CHANGE_TAB } from '../actions/ui';
import { TABS } from '../../constants';

export const emptyState = {
  activeTab: TABS.IMPORTS,
};

export default function(state = emptyState, action) {
  switch (action.type) {
  case CHANGE_TAB: {
    return {
      ...state,
      activeTab: action.tab,
    };
  }
  default:
    return state;
  }
}
